/* eslint-disable react/jsx-key */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Menu, Layout,
} from 'antd';
import H3Image from '@Uilib/h3Image';
import TenantActions from '@Actions/tenantActions';
import UserActions from '@Actions/userActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleMinus, faGear, faHandshake, faHouse, faLinkSlash, faTags, faUser, faUserTag } from '@fortawesome/free-solid-svg-icons';
import { cdnUrl } from '@Utils/cdnHelper';

const { Sider } = Layout;

/**
 *
 */
class UserMenuAdminCollapsed extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      openKeys: [],
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      getOrg, user,
    } = this.props;
    getOrg(user?.tenant_info?.org_id);
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.userReady) {
      props.getTenantsConfiguration(props.user?.tenant_info?.tenant_id);
      return {
        ...state,
        userReady: true,
        currentPage: props?.history?.location?.pathname,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      user, org,
      tenantsConfiguration,
    } = this.props;
    const {
      currentPage, collapse, openKeys, collapsed,
    } = this.state;
    return (
      <Fragment>
        {/* <Layout style={{ minHeight: 'calc(100dvh - 80px)', position: 'relative' }}> */}
        <Layout>
          <div className="user-menu hide__in-mobile">
            <Sider
              width={230}
              collapsible
              collapsed={collapsed}
              onMouseEnter={() => this.setState({ collapsed: false })}
              onMouseLeave={() => this.setState({ collapsed: true })}
              style={{
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                zIndex: 15,
              }}
            >
              <div className="user-menu__wrapper__collapsed">
                <div className="user-menu__logo-menu__item">
                  <Menu
                    inlineCollapsed={false}
                    theme="light"
                    mode="inline"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  >
                    <Menu.Item
                      onClick={() => {
                        this.props.history.push('/');
                        this.setState({ currentPage: '/' });
                      }}
                      icon={!user?.tenant_info?.global_config?.settings?.white_label_platform ? (
                        <div className="user-menu__logo-collapsed">
                          <img src="/favicon.ico" alt="Favicon" className="user-menu__logo-image-wl" />
                        </div>
                      ) : (
                        <div className="user-menu__logo-wl__collapsed">
                          <div className="user-menu__logo-image-left-wrapper">
                            <H3Image
                              src={org?.organisation?.[0]?.logo}
                              className="user-menu__logo-image-left"
                            />
                          </div>
                        </div>)}>
                      <div className="user-menu__logo-wl__collapsed">
                        <div className={user?.tenant_info?.global_config?.settings?.white_label_platform ? 'user-menu__logo-image-right-wrapper' : 'user-menu__logo-image-right-wrapper-wl'}>
                          {user?.tenant_info?.global_config?.settings?.white_label_platform && (
                            <div
                              className="user-menu__logo-image-right-header">
                              Powered by
                            </div>)}
                          <H3Image
                            src={cdnUrl('logo-without-tagline.png', 'images')}
                            className={user?.tenant_info?.global_config?.settings?.white_label_platform ? 'user-menu__logo-image-right' : 'user-menu__logo-image-right-wl'}
                          />
                        </div>
                      </div>
                    </Menu.Item>
                  </Menu>
                </div>
                <Menu
                  selectedKeys={[currentPage]}
                  defaultSelectedKeys={['/admin/business-units']}
                  theme="light"
                  openKeys={openKeys}
                  onClick={(value) => {
                    const { history } = this.props;
                    history.push(value.key);
                    this.setState({ currentPage: value.key });
                  }}
                  mode="inline"
                  style={{
                    padding: '0px !important',
                    marginTop: '60px',
                  }}
                >
                  <Menu.Item key="/admin/business-units" icon={<FontAwesomeIcon icon={faHouse} />}>Business Units</Menu.Item>
                  <Menu.Item key="/admin/users" icon={<FontAwesomeIcon icon={faUser} />}>Users</Menu.Item>
                  <Menu.Item key="/admin/inventory" icon={<FontAwesomeIcon icon={faTags} />}>Inventory</Menu.Item>
                  <Menu.Item key="/admin/vendors" icon={<FontAwesomeIcon icon={faHandshake} />}>Vendors</Menu.Item>
                  <Menu.Item key="/admin/customers" icon={<FontAwesomeIcon icon={faUserTag} />}>Customers</Menu.Item>
                  <Menu.Item key="/admin/configuration" icon={<FontAwesomeIcon icon={faGear} />}>Configuration</Menu.Item>
                  <Menu.Item key="/admin/integration" icon={<FontAwesomeIcon icon={faLinkSlash} />}>Integrations</Menu.Item>
                  <Menu.Item key="/" icon={<FontAwesomeIcon icon={faCircleMinus} />}>Exit Admin</Menu.Item>
                </Menu>
              </div>
            </Sider>
          </div>
        </Layout>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserReducers, TenantReducers }) => ({
  user: UserReducers.user,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,
  org: UserReducers.org,
});

const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId)),
  getTenantsConfiguration: (tenantId) => dispatch(TenantActions.getTenantsConfiguration(tenantId)),
  getOrg: (orgId) => dispatch(UserActions.getOrg(orgId)),

});

UserMenuAdminCollapsed.propTypes = {
  user: PropTypes.any,
  org: PropTypes.any,
  history: PropTypes.any,
  tenantsConfiguration: PropTypes.any,
  getTenantsConfiguration: PropTypes.func,
  getOrg: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserMenuAdminCollapsed));
